import Button from "../../lds/Button";

export default function ListPageFooter({
  onLoadMore,
  footerText,
  disableLoadMore,
}) {
  const variant = disableLoadMore ? "disable" : "primary";

  return (
    <div className="container w-1200 footer-container">
      <div className="footer-row">
        <div className="footer-item" />
        <div className="footer-item count-text">{footerText}</div>
        <div className="footer-item" />
      </div>
      <div className="footer-row">
        <div className="footer-item" />
        <div className="footer-item button">
          <Button size="medium" variant={variant} onClick={onLoadMore}>
            Load More
          </Button>
        </div>
        <div className="footer-item" />
      </div>
    </div>
  );
}
